






































import {Component, Vue, Watch} from 'vue-property-decorator';
import {ProjectTimeEntryViewModel, RateRuleAmountFilter, StSelectListItem, StSelectListItemGroup, TagViewModel, TimeEntryEditModel, TimeEntryTypeEnum,} from '@/services/api/nswag/stapiclient_generated';
import {stCustomerApi, stProjectApi, stProjectTaskApi, stRateRuleApi, stTagApi, stTimeEntryApi} from '@/services/st-api';
import {UserStore} from '@/store/user-module';
import SlideIn from '@/components/basic/SlideIn.vue';
import {notifySuccess} from '@/utlitities/notifications';
import StInput2 from '@/components/basic/StInput2.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import StDurationPicker from '@/components/basic/StDurationPicker.vue';
import {DateTime} from 'luxon';
import StToggle from '@/components/basic/StToggle.vue';

@Component({
    components: {
      StToggle,
      StDurationPicker,
      StTextarea,
      StInput2,
      SlideIn,
    },
  })
  export default class PauseEdit extends Vue {
    private id: number = 0;
    private entryDate: string = '';
    private timeEntry: TimeEntryEditModel = TimeEntryEditModel.fromJS({});
    private loading: boolean = true;
  private btnLoading: boolean = false;
    private listPage: string = 'TimeEntries';

    projects: StSelectListItemGroup[] = [];
    projectTasks: StSelectListItem[] = [];
    projectTasksGrouped: StSelectListItemGroup[] = [];
    selectedProject: ProjectTimeEntryViewModel = ProjectTimeEntryViewModel.fromJS({});
    tags: TagViewModel[] = [];

    openSlideIn() {
      (this.$refs.slideIn as SlideIn).open();
    }

    closeSlideIn() {
      (this.$refs.slideIn as SlideIn).close();
    }

    slideOutClosed() {
      this.$router.push({ name: this.listPage });
    }

    created() {
      this.id = parseInt(this.$route.params.id);
      this.entryDate = this.$route.params.entryDate;
    }

    get userSettings() {
      return UserStore.userSettings;
    }

    async mounted() {
      this.openSlideIn();
      this.timeEntry = this.id == 0 ? await stTimeEntryApi.getNew(TimeEntryTypeEnum.Pause, this.entryDate) : await stTimeEntryApi.get(this.id);

      this.loading = false;
    }

    async submit() {
      try {
        this.btnLoading = true;
        if (this.timeEntry.id == 0) {
          await stTimeEntryApi.post(this.timeEntry);
        } else {
          await stTimeEntryApi.put(this.timeEntry.id, this.timeEntry);
        }
        notifySuccess('Erfolgreich gespeichert');
        this.closeSlideIn();
      } finally {
        this.btnLoading = false;
      }
    }

    timeChanged(type: string) {
      if (!this.timeEntry?.timeFrom || !this.timeEntry?.timeTo) {
        return;
      }

      let timeFromLuxon = DateTime.fromFormat(this.timeEntry.timeFrom!, 'HH:mm');
      let timeToLuxon = DateTime.fromFormat(this.timeEntry.timeTo!, 'HH:mm');

      if (type == 'timeFrom') {
        if (timeFromLuxon.toMillis() > timeToLuxon.toMillis()) {
          this.timeEntry.timeTo = this.timeEntry.timeFrom;
        }
      } else {
        if (timeToLuxon.toMillis() < timeFromLuxon.toMillis()) {
          this.timeEntry.timeFrom = this.timeEntry.timeTo;
        }
      }

      timeFromLuxon = DateTime.fromFormat(this.timeEntry.timeFrom!, 'HH:mm');
      timeToLuxon = DateTime.fromFormat(this.timeEntry.timeTo!, 'HH:mm');

      this.timeEntry.durationMinutes = timeToLuxon.diff(timeFromLuxon, ['minutes']).minutes;

      if(!this.timeEntry.durationMinutes){
        this.timeEntry.durationMinutes = 0;
      }
    }
  }
